import { parseEnv } from "./env.parse";
import { SharedEnvironmentSchema } from "./env.schema";

const parsedEnv = parseEnv(SharedEnvironmentSchema);

export const sharedEnv = {
  deployAlias: parsedEnv.NX_PUBLIC_DEPLOY_ALIAS,
  reviewId: parsedEnv.NX_PUBLIC_REVIEW_ID,
  hostOverrides: {
    coreApi: parsedEnv.NX_PUBLIC_CORE_API_URL,
    accountApi: parsedEnv.NX_PUBLIC_ACCOUNT_API_URL,
    adminApi: parsedEnv.NX_PUBLIC_ADMIN_API_URL,
  },
} as const;
